import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@proptr/api-client/react';
import { createClient } from '@proptr/api-client';
import { ThemeProvider } from '@proptr/ui';
import './index.css';
import { App } from './App.js';

export const client = createClient({
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  app: 'admin',
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider client={client}>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
